<template>
  <div class="home__category-list">
    <h2 v-if="showTitle" class="_special" v-html="title"></h2>
    <div class="catalog__category-list slider__container">
      <swiper :ref="sliderId" :options="slideOptions">
        <swiper-slide v-for="product in products" :key="product.product_id">
          <product-list-item
              :data-source="'dataSource'"
              :product="product" type="recent">
          </product-list-item>
        </swiper-slide>
      </swiper>
      <div class="slider__controls" :class="sliderId">
        <div class="slider__control prev" slot="button-prev"></div>
        <div class="slider__control next" slot="button-next"></div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import {apiClient} from '../../shared/services/api-client';
import {appSessionStorage} from '../../shared/services/app-storage';
import ServiceContainer from '@flashpointbv/solar-service-container';
import {Swiper, SwiperSlide, directive} from 'vue-awesome-swiper';
import { SolarDataLayer } from '@flashpointbv/solar-datalayer/dist';
import 'swiper/css/swiper.css';

@Component({
  name: 'home-list',
  components: {
    'product-list-item': ServiceContainer().getComponent('catalog-product-list-item'),
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  }
})

export default class extends Vue {
  @Prop({required: true}) readonly sliderId!: string;
  @Prop({default: ''}) readonly title!: string;
  @Prop({default: ''}) readonly buttonText!: string;
  @Prop({default: null}) readonly buttonUrl!: null | string;
  @Prop({default: true}) readonly showTitle!: boolean;
  @Prop({default: false}) readonly special!: boolean;
  @Prop({default: null}) readonly productSku!: null | Array<string>;
  @Prop({default: null}) readonly tab!: null | string;

  private products: Array<object> = [];
  private isLoading: boolean = false;

  @Watch('tab')
  private async tabChangeHandler() {
    this.products = await this.fetchProducts();
  };

  private slideOptions: object = {
    slidesPerView: 2,
    spaceBetween: 12,
    navigation: {
      nextEl: `.${this.sliderId} .next`,
      prevEl: `.${this.sliderId} .prev`
    },
    breakpoints: {
      768: {
        slidesPerView: 3
      },
      1024: {
        slidesPerView: 4
      },
      1200: {
        slidesPerView: 5
      }
    }
  };

  private async created(): Promise<void> {
    this.products = await this.fetchProducts();
    SolarDataLayer.init().addViewItemsList(this.products, this.sliderId);
  };

  private get fetchProductRequestParams() {
    let params = {};

    if (null !== this.productSku && this.productSku.length) {
      params['sku'] = this.productSku;
    }

    return params;
  };

  private get storageCacheKey() {
    return `home-list.${this.sliderId}` + (this.tab ? `.${this.tab}` : '') + '.products';
  };

  private async fetchProducts() {
    const cacheData = appSessionStorage.getItem(this.storageCacheKey);

    if (cacheData && null === this.productSku) {
      return cacheData;
    }

    this.isLoading = true;

    try {
      const {data} = await apiClient.get(`/api/catalog/product-sets/${this.sliderId}` + (this.tab ? `-${this.tab}` : ''), {
        params: this.fetchProductRequestParams
      });

      appSessionStorage.setItem(this.storageCacheKey, data);

      return data;
    } catch (er) {
      return [];
    } finally {
      this.isLoading = false;
    }
  };

  updated(): void {
    setTimeout(() => {
      ('.home__category-list a h2').matchHeight(true);
    }, 100);
  }
}
</script>
